var QtyInput = (function () {
  var $qtyInputs = $(".qty-input");

  var numericValue = 0; // Holds the maximum allowed quantity
  var totalQuantity = 0; // Keeps track of the current total quantity
  var isInitialLoad = true; // Flag to prevent alert on page load

  if (!$qtyInputs.length) {
    return;
  }

  var $inputs = $qtyInputs.find(".product-qty");
  var $countBtn = $qtyInputs.find(".qty-count");
  var qtyMin = parseInt($inputs.attr("min"));
  var qtyMax = parseInt($inputs.attr("max"));

  // Function to update the total quantity
  function updateTotalQuantity() {
    
    totalQuantity = 0;

    // Calculate total quantity
    $inputs.each(function () {
      let qty = parseInt($(this).val()) || 0;
      totalQuantity += qty;
    });

    // Update the total quantity display
    $("#total-quantity-display").text(totalQuantity);

    // Update pending quantity
    let pendingQuantity = numericValue - totalQuantity;
    if (pendingQuantity >= 0) {
      $("#cart_no").text(pendingQuantity);
      if (pendingQuantity === 0) {
        $(".product_addbox").hide();
        $("#box-full").show();
        $(".custom_box_product .buy-buttons button.button.w-full").prop(
          "disabled",
          false
        );
        //alert("FULL");
      }
    }

    // Check for maximum limit, but skip alert during the initial load
    if (totalQuantity >= numericValue) {
      if (!isInitialLoad) {
        $("#box-full").show();
        $(".custom_box_product .buy-buttons button.button.w-full").prop(
          "disabled",
          false
        );
        $(".product_addbox").hide(); // Hide the product_addbox
        //alert("Your Bonbon box is full !!");
      }
    } else {
      $(".custom_box_product .buy-buttons button.button.w-full").prop(
        "disabled",
        true
      );
      $(".product_addbox").show(); // Show the product_addbox
      $("#box-full").hide();
    }

    console.log("Total Quantity:", totalQuantity);
  }

  // Function to initialize or update numericValue
  function get_numeric_value(updatedValue) {
    numericValue = updatedValue.match(/\d+/); // Extract digits
    if (numericValue) {
      numericValue = parseInt(numericValue[0]);
      $("#cart_no").text(numericValue);
      $("#cart_min_quantity_notify").text(numericValue);
      $("#cart_max_quantity_notify").text(numericValue);
    
      console.log("Updated Numeric Value:", numericValue);

      // Determine the minimum value based on numericValue
      let minQuantity = 1; // Default min quantity

      if (numericValue === 4) {
        minQuantity = 5;
      } else if (numericValue === 6) {
        minQuantity = 2;
      }


     $(".cust_mess_textarea").attr("data-value", minQuantity);
      $(".quantity-selector__input").attr("min", minQuantity);
       $(".quantity-selector__input").attr("min", minQuantity);
      // Ensure the current value is at least the min value
      $(".quantity-selector__input").each(function () {
        let currentVal = parseInt($(this).val());
        if (currentVal < minQuantity) {
          $(this).val(minQuantity);
        }

        // Enable or disable the decrease button based on minQuantity
        let decreaseButton = $(this)
          .closest(".quantity-selector")
          .find(".quantity-selector__button.decrease");
        if (currentVal > minQuantity) {
          decreaseButton.removeAttr("disabled"); // Enable if value > min
        } else {
          decreaseButton.attr("disabled", "disabled"); // Disable if value == min
        }
      });

      // Recalculate total on numeric value update
      updateTotalQuantity();
    }
  }

  $inputs.change(function () {
    var $this = $(this);
    var qty = parseInt($this.val());

    if (isNaN(qty) || qty <= qtyMin) {
      $this.val(qtyMin);
    } else if (qty > qtyMax) {
      $this.val(qtyMax);
    }

    updateTotalQuantity();
  });

  $countBtn.click(function () {
    var operator = this.dataset.action;
    var $this = $(this);
    var $input = $this.siblings(".product-qty");
    var qty = parseInt($input.val());

    if (operator == "add") {
      if (totalQuantity < numericValue) {
        qty += 1;
        var custq = totalQuantity + 1;
        if (custq === numericValue) {
          $(".product_addbox").hide();
          $("#box-full").show();
          $(".custom_box_product .buy-buttons button.button.w-full").prop(
            "disabled",
            false
          );
        }
      } else {
        alert("Maximum items added to the cart.");
        $("#box-full").show();
        $(".product_addbox").hide(); // Hide the product_addbox
        return;
      }
    } else if (operator == "minus") {
      qty = Math.max(qty - 1, qtyMin);
      $(".custom_box_product .buy-buttons button.button.w-full").prop(
        "disabled",
        true
      );
      $(".product_addbox").show(); // Show the product_addbox when reducing quantity
      $("#box-full").hide();
    }

    $input.val(qty).trigger("change");
  });

  // Initially hide the quantity selector
  $(".quantity-wrapper").hide();

  // Show quantity selector, increment total by 1, and hide button on "Add to Cart" click
  $(".button_add_cart").on("click", function () {
    var $this = $(this);
    var $qtyInput = $this.siblings(".quantity-wrapper").find(".product-qty");
    if (totalQuantity < numericValue) {
      // Increment the input value by 1
      var currentQty = parseInt($qtyInput.val()) || 0;
      $qtyInput.val(currentQty + 1).trigger("change");
      // Hide the button and show the quantity selector
      $this.hide();
      var container = $(this).closest(".cube-container");
      container.find(".close-icon").show();
      $this.siblings(".quantity-wrapper").show();
    } else {
      alert("Maximum items added to the cart.");
      $("#box-full").show();
      $(".product_addbox").hide(); // Hide the product_addbox
      return;
    }
  });

  // Initialize numericValue and fetch current value
  $(document).ready(function () {
    function getBoxTypeValue() {
    let value = '';

    // Case 1: Box Type dropdown
    const boxSelect = document.querySelector(
    'select[name="options[Box Type]"], select[name="options[option1]"]'
    );

    // Case 2: Box Type radio
    const checkedRadio = document.querySelector(
    'input[name="options[Box Type]"]:checked, input[name="options[option1]"]:checked'
    );

    console.log("boxSelect", boxSelect);
    console.log("checkedRadio", checkedRadio);

    if (boxSelect) {
    value = boxSelect.value;
    } else if (checkedRadio) {
    const label = checkedRadio.closest('label');
    value = label ? label.innerText.trim() : '';
    }

    if (value) {
    get_numeric_value(value);
    }
    }

    //getCurrentValue(); // On page load
    getBoxTypeValue();

    $(document).on(
    "click",
    ".popover__value-list .popover__value-option",
    function () {
    var updatedValue = $(this).find("span:first").text().trim();
      if (/\d+\s*pcs/i.test(updatedValue)) {
        console.log("updatedValue", updatedValue);
        resetvalues(updatedValue);
        get_numeric_value(updatedValue);
      }

    //console.log("updatedValue", updatedValue);
    //resetvalues(updatedValue);
    //get_numeric_value(updatedValue);
    }
    );

    // Reset flag after initial load
    setTimeout(() => {
      isInitialLoad = false;
    }, 500);
  });

  $(document).on("click", ".close-icon button", function () {
    $(this).closest("article").find(".product-qty").val(0);
    $(this).closest("article").find(".quantity-wrapper").hide();
    $(this).closest("article").find(".button_add_cart").show();
    var dataId = $(this).data("id");
    $('input.custom_pack_product[name="properties[' + dataId + ']"]').remove();
    updateTotalQuantity();
    $(this).hide();
  });

  updateTotalQuantity();
})();

function resetvalues(updatedValue) {
  // Reset all relevant values and UI components
  $(".product-qty").val(0); // Reset all product quantity inputs to 0
  $(".button_add_cart").show(); // Show the "Add to Cart" buttons
  $(".quantity-wrapper").hide(); // Hide all quantity selectors
  $(".custom_pack_product").remove(); // Remove all dynamically added hidden inputs
  $(".product_addbox").show(); // Reset the visibility of the product box
  $("#total-quantity-display").text(0); // Reset the total quantity display
  $("#cart_no").text(updatedValue); // Reset the pending quantity display
  $(".cube-container span.close-icon").hide();
  $("#box-full").hide();
  $(".custom_box_product .buy-buttons button.button.w-full").prop(
    "disabled",
    true
  );

  // Log the reset operation for debugging
  console.log("All values reset after selecting a new value:", updatedValue);
}

jQuery(document).ready(function () {
  function updateHiddenInput($qtyInput, cus_product_id, cus_product_name) {
    // Get the dynamic quantity
    var currentQty = parseInt($qtyInput.val()) || 0;

    // Remove any existing hidden input for this product
    $(`.custom_pack_product[name="properties[${cus_product_id}]"]`).remove();

    // Define the hidden input element with the dynamic quantity
    var deliveryInput = `
      <input type="hidden" 
             class="custom_pack_product" 
             name="properties[${cus_product_id}]" 
             value="${cus_product_name} x${currentQty}">
    `;
    console.log(deliveryInput);
    if (currentQty > 0) {
      // Append the updated hidden input to the form
      $(".product-info__block-item .shopify-product-form").append(
        deliveryInput
      );
    }

    console.log("Hidden input updated in product form.");
  }

  // Event for "Add to Cart" button
  $(".button_add_cart").on("click", function () {
    var $this = jQuery(this);
    var cus_product_id = $this.data("id");
    var cus_product_name = $this.data("title");
    var $qtyInput = $this.siblings(".quantity-wrapper").find(".product-qty");
    var currentQty = parseInt($qtyInput.val()) || 0;
    // Increment quantity by 1 when adding to cart
    //var currentQty = parseInt($qtyInput.val()) || 0;
    //$qtyInput.val(currentQty + 1).trigger("change");

    // Update the hidden input
    updateHiddenInput($qtyInput, cus_product_id, cus_product_name);

    // Hide the button and show the quantity selector
    if (currentQty > 0) {
      $this.hide();
      $this.siblings(".quantity-wrapper").show();
    }
  });

  // Event for plus and minus buttons
  $(".qty-count").on("click", function () {
    var $this = jQuery(this);
    var $qtyInput = $this.siblings(".product-qty");
    var cus_product_id = $this
      .closest(".quantity-wrapper")
      .siblings(".button_add_cart")
      .data("id");
    var cus_product_name = $this
      .closest(".quantity-wrapper")
      .siblings(".button_add_cart")
      .data("title");

    // Update the hidden input after the quantity changes
    setTimeout(() => {
      updateHiddenInput($qtyInput, cus_product_id, cus_product_name);
    }, 100); // Small delay to ensure quantity is updated
  });

  // Event for direct input changes
  $(".product-qty").on("change", function () {
    var $this = jQuery(this);
    var cus_product_id = $this
      .closest(".quantity-wrapper")
      .siblings(".button_add_cart")
      .data("id");
    var cus_product_name = $this
      .closest(".quantity-wrapper")
      .siblings(".button_add_cart")
      .data("title");

    // Update the hidden input immediately
    updateHiddenInput($this, cus_product_id, cus_product_name);
  });
});

jQuery(document).ready(function ($) {
  $(".custom_box_product .buy-buttons button.button.w-full").on(
    "click",
    function (e) {
      // Get the values of total-quantity-display and cart_max_quantity_notify
      var totalQuantity = parseInt(
        $("#total-quantity-display").text().trim(),
        10
      );
      var maxQuantity = parseInt(
        $("#cart_max_quantity_notify").text().trim(),
        10
      );
      // Check if totalQuantity is equal to maxQuantity
      if (totalQuantity !== maxQuantity) {
        e.preventDefault(); // Prevent the default add-to-cart action
        alert("Box is Not Full"); // Show the message
      }
    }
  );
});

$(document).ready(function () {
  $(".custom_box_product .buy-buttons button.button.w-full").prop(
    "disabled",
    true
  );
});




